export const sendOtpApi = async (mobile) => {
  try {
    const response = await fetch(
      `https://khata.moxpal.com/api/auth/send_otp.php?mobile=${mobile}`
    )

    const data = await response.json()
    return data
  } catch (error) {
    return {
      status: false,
      message: 'Something went wrong. Please try again.',
    }
  }
}

export const verifyOtpApi = async (mobile, otp) => {
  try {
    const response = await fetch(
      'https://khata.moxpal.com/api/auth/verify_otp.php',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          mobile,
          otp,
          device_id: 'web-browser',
          device_name: navigator.userAgent,
        }),
      }
    )

    const data = await response.json()
    return data
  } catch (error) {
    return {
      status: false,
      message: 'Network error',
    }
  }
}